import React from 'react';
import { Button, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { paths } from '@/app/paths';
import { ImportFileButton } from '@/admin/imports/ImportsTable/ImportFileButton';
import { isUserImportDone, useGetUserImportQuery } from '../../api/userImportsApi';
import { UserImportStatusChip } from '../UserImportStatusChip';

/**
 * The user import report's heading: a button that downloads the uploaded file, its name and
 * the status chip, then Import another file once the import is done.
 */
export const UserImportReportHeader = ({ importId }) => {
	const navigate = useNavigate();
	const { data: userImport } = useGetUserImportQuery(importId);
	const { status, fileName, storagePath } = userImport;

	return (
		<Stack direction='row' spacing={1} sx={{ justifyContent: 'space-between' }}>
			<Stack direction='row' spacing={1} alignItems='center'>
				<ImportFileButton storagePath={storagePath} fileName={fileName} />
				<Typography variant='form_label'>{fileName}</Typography>
				<UserImportStatusChip status={status} />
			</Stack>
			{isUserImportDone(userImport) && (
				<Button variant='outlined' onClick={() => navigate(`${paths.admin}/import/users`)}>
					Import another file
				</Button>
			)}
		</Stack>
	);
};
